/**
 * Normalize role strings from API / localStorage (spacing, case, enum quirks).
 */
export function normalizeRoleType(raw) {
  if (raw == null) return '';
  return String(raw)
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
}

export function isSuperAdminUser(user) {
  if (!user || typeof user !== 'object') return false;
  const t = normalizeRoleType(user.user_type ?? user.role);
  return t === 'superadmin';
}

export function isAdminOrSuperUser(user) {
  if (!user || typeof user !== 'object') return false;
  const t = normalizeRoleType(user.user_type ?? user.role);
  return t === 'superadmin' || t === 'admin';
}
